import Profile from "../models/Profile";

const ProfileStore = Profile.create();

export default ProfileStore;
